import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class VideoComment extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get header() {
    return get(this, '_naglowek.value', '');
  }

  get letterLink() {
    return get(this, '_list.value[0].url', '');
  }

  get videoPoster() {
    return get(this, '_plakat_filmu.value[0].url', '');
  }

  get videoLink() {
    return get(this, '_link_do_filmu.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/VideoComment.js